import { create } from "zustand";

export const MOBILE_BREAKPOINT = 680;

const useWindowWidthStore = create(() => ({
  width: window.innerWidth,
}));

window.addEventListener("resize", () => {
  useWindowWidthStore.setState({ width: window.innerWidth });
});

export default function useIsMobile(width = MOBILE_BREAKPOINT) {
  return useWindowWidthStore((state) => state.width <= width);
}
